import axios from "axios"
import React, { Component } from "react"
import { Button, Modal, Spinner } from "react-bootstrap"
import AxiosConfig from "../../../../../utilities/AxiosConfig"
import snackBar from "../../../../../utilities/snackBar/SnackBar"
import EmployeeDataTypes from "../../../Types/EmployeeTypes"
import "./EmployeeActive.css"

interface EmployeeActiveProps {
    queryParams: EmployeeDataTypes
    togglePrompt: Function
    activate: boolean
    updateCallback: Function
}

type EmployeeActiveTypes = {
    loading: boolean
}

class Active extends Component<EmployeeActiveProps, EmployeeActiveTypes>{

    state = {
        loading: false
    }

    updateActiveState = () => {
        this.setState({ loading: true })
        let employee = this.props.queryParams
        employee.Inactive = !this.props.activate
        if (this.props.activate && !employee.TerminationDate) {
            employee.TerminationDate = null
        } else {
            // employee.TerminationDate = moment(Date.now()).format()
        }
        if(!employee.LocationCode){
            employee.LocationCode = "NONE"
        }
        axios.post(process.env.REACT_APP_API_URL + "/api/user", employee, AxiosConfig.configValue("min"))
            .then(() => {
                if (this.props.activate) {
                    snackBar({ text: "Employee Activated", type: "success", timeout: 3000 })
                    this.props.togglePrompt("activatePrompt")
                } else {
                    snackBar({ text: "Employee Deactivated", type: "success", timeout: 3000 })
                    this.props.togglePrompt("deactivatePrompt")
                }
                this.props.updateCallback(employee)
                this.setState({ loading: false })
            })
            .catch(err => {
                //console.log(err);
                snackBar({ text: "Error Updating Active State", type: "error", timeout: 3000 })
                if (this.props.activate) {
                    this.props.togglePrompt("activatePrompt")
                } else {
                    this.props.togglePrompt("deactivatePrompt")
                }
                this.setState({ loading: false })
            })
    }

    render() {
        return (
            <div className="EmployeeActive">
                <Modal id="hr-deactivate-modal"
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                >
                    <Modal.Header>
                        {!this.state.loading && this.props.activate && <div id="activate-employee-header"><p>Activate this employee?</p></div>}
                        {this.state.loading && this.props.activate && <div id="activate-employee-header"><p>Activating employee...</p><Spinner id="active-status-update-spinner" animation="border" /></div>}
                        {!this.state.loading && !this.props.activate && <div id="activate-employee-header"><p>Deactivate this employee?</p></div>}
                        {this.state.loading && !this.props.activate && <div id="activate-employee-header"><p>Deactivating employee...</p><Spinner id="active-status-update-spinner" animation="border" /></div>}
                    </Modal.Header>
                    <Modal.Footer>
                        <div id="hr-discard-deactivate-modal-footer" >
                            {this.props.activate && <Button id="hr-deactivate-modal-footer-quit-btn" variant="secondary" onClick={() => this.props.togglePrompt("activatePrompt")}>No</Button>}
                            {!this.props.activate && <Button id="hr-deactivate-modal-footer-quit-btn" variant="secondary" onClick={() => this.props.togglePrompt("deactivatePrompt")}>No</Button>}
                            <Button id="hr-discard-modal-footer-back-btn" variant="success" onClick={() => this.updateActiveState()}>Yes</Button>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

export default Active